import { ItemListTabsMaterialProps } from 'types/itemListTabsMaterialProps';

export const tabsList: ItemListTabsMaterialProps[] = [
	{
		id: 0,
		name: 'Dados',
		disabled: false
	},
	{
		id: 1,
		name: 'Produtos',
		disabled: false
	}
];
